import { isBefore, isValid, parse, startOfDay } from 'date-fns';

export const validateExpirationDate = (value: string): string | true => {
  if (value?.length < 8) return 'Please fill out this field';

  const expDate = parse(value, 'MMddyyyy', new Date());

  if (!isValid(expDate)) return 'Please enter a valid date';

  return isBefore(expDate, startOfDay(new Date()))
    ? 'Your medical ID has expired'
    : true;
};
